import React from 'react';
import PropTypes from 'prop-types';
import tw, { styled } from 'twin.macro';
import chroma from 'chroma-js';

import { motion } from '@ubisend/framer-motion';
import { Markdown as PulseMarkdown } from '@ubisend/pulse-markdown';

const StyledBubble = styled(motion.div)(({ theme }) => [
  tw`whitespace-normal`,
  `
    & > div > p {
      margin: 0;
    }

    & > div > p > code {
      color: ${theme.primary};
    }

    & > div > div[type="note"] * {
      color: ${theme.white};
    }

    & > pre,
    & > div > pre,
    & > div > p > code,
    & > div > h1 > code {
      background: ${chroma(theme.primary).alpha(0.2).css()};
    }
  `
]);

const Markdown = ({ content }) => (
  <StyledBubble className="message-type-markdown">
    <PulseMarkdown isBubble>{content.text}</PulseMarkdown>
  </StyledBubble>
);

Markdown.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default Markdown;